import Axios from "axios";
import { action, decorate, observable } from "mobx";
import moment from "moment";
import { Constant } from "../../../../config/Constant";
import ServerGridConfig from "../../../../config/ServerGridConfig";

export default class AccountExpensePaymentSummaryStore {
    filter = null;
    agGridList = null;
    per_page_list = ServerGridConfig.options.paginationPageSize;
    current_page_list = 1;
    list_data = null;
    total_list = 0;
    allColumnIdsList = [];
    isSelectAll = false;
    selectCount = 0;
    paymentDetails = null;
    summaryAllArr = [];
    visibleRowCount = 0;
    selectedRowCount = 0;
    summary_list_filter = null;
    agGridSummaryList = null;
    per_page_summary_list = ServerGridConfig.options.paginationPageSize;
    current_page_summary_list = 1;
    list_data_summary_list = null;
    total_summary_list = 0;
    allColumnIdsSummaryList = [];
    viewValues = null;
    deleteValues = null;
    isTerminated = 0;
    isExistingSummary = 0;
    dropdown_summary_list = null;

    setIsExistingSummary = data => {
        this.isExistingSummary = data;
    };

    setPaymentDetails = data => {
        this.paymentDetails = data;
        return true;
    };

    setViewValues = data => {
        this.viewValues = data;
    };

    // set form values to delete
    setDeleteValues = data => {
        this.deleteValues = data;
    };

    setIsTerminated = is_terminated => {
        this.isTerminated = is_terminated;
    };

    // change page size, default page size is ServerGridConfig.options.paginationPageSize
    setPageSizeSummaryList = (page = this.per_page_summary_list) => {
        this.per_page = page;
        if (this.agGridSummaryList) {
            this.agGridSummaryList.api.deselectAll();
            this.agGridSummaryList.api.paginationSetPageSize(parseInt(page));
        }
    };

    // Filter function for no record found message
    changeFilterAndSort = params => {
        var final_filter = params.filterModel;
        var final_sort = params.sortModel;
        return { final_filter, final_sort };
    };

    // Create data source to display record in table
    createDatasource = gridOptions => {
        return {
            gridOptions,
            getRows: params => {
                var filter_data = this.changeFilterAndSort(params.request);
                var payload = {
                    filter_data: filter_data.final_filter,
                    sort_data: filter_data.final_sort,
                    per_page: params.request.endRow - params.request.startRow,
                    advance_filter: this.summary_list_filter
                        ? this.generatePayload(this.summary_list_filter)
                        : this.generatePayload(this.filter),
                    page: Math.ceil((params.request.startRow + 1) / (params.request.endRow - params.request.startRow)),
                };
                if (this.summary_list_filter) {
                    payload.is_terminated = this.isTerminated;
                }
                this.summary_list_filter
                    ? this.getSummaryList(payload).then(data => {
                          if (data.list.total === 0) {
                              this.agGridSummaryList.api.showNoRowsOverlay();
                          } else {
                              this.agGridSummaryList.api.hideOverlay();
                          }
                          params.successCallback(data.list.data, data.list.total);
                          var allColumnIdsSummaryList = [];
                          if (this.agGridSummaryList && this.agGridSummaryList.columnApi && data.total) {
                              this.agGridSummaryList.columnApi.getAllColumns().forEach(function (column) {
                                  allColumnIdsSummaryList.push(column.col_id);
                              });
                          }
                      })
                    : this.getList(payload).then(data => {
                          if (data.list.total === 0) {
                              this.agGridList.api.showNoRowsOverlay();
                          } else {
                              this.agGridList.api.hideOverlay();
                          }
                          params.successCallback(data.list.data, data.list.total);
                          var allColumnIds = [];
                          if (this.agGridList && this.agGridList.columnApi && data.total) {
                              this.agGridList.columnApi.getAllColumns().forEach(function (column) {
                                  allColumnIds.push(column.col_id);
                              });
                          }
                      });
            },
        };
    };

    // set form values to  customefilter
    setListFilterValues = (data = null) => {
        return new Promise(resolve => {
            this.filter = data;
            if (this.agGridList) {
                this.setupGridList(this.agGridList);
            }
            resolve();
        });
    };

    // set form values to  customefilter
    setSummaryListFilterValues = (data = null) => {
        return new Promise(resolve => {
            this.summary_list_filter = data;
            if (this.agGridSummaryList) {
                this.setupGridSummaryList(this.agGridSummaryList);
            }
            resolve();
        });
    };

    // Setup grid and set column size to autosize
    setupGridList = params => {
        this.agGridList = params;
        const { api } = params;
        let datasource = this.createDatasource(ServerGridConfig.options);
        api.setServerSideDatasource(datasource);
    };

    // Setup grid and set column size to autosize
    setupGridSummaryList = params => {
        this.agGridSummaryList = params;
        const { api } = params;
        let datasource = this.createDatasource(ServerGridConfig.options);
        api.setServerSideDatasource(datasource);
    };

    // change page size, default page size is LocalGridConfig.options.paginationPageSize
    setPageSizeList = (page = this.per_page_list) => {
        this.per_page_list = page;
        if (this.agGridList) {
            this.agGridList.api.paginationSetPageSize(parseInt(page));
        }
    };

    // Filter function for no record found message
    onFilterChangedList = params => {
        if (this.agGridList) {
            this.agGridList.api.deselectAll();
            this.setupGridList(this.agGridList);
            this.setSummaryAllArr([]);
            this.setVisibleRowCount(0);
            this.setSelectedRowCount(0);
        }
        this.agGridList = params;
        if (this.agGridList && this.agGridList.api.getModel().getRowCount() === 0) {
            this.agGridList.api.showNoRowsOverlay();
        }
        if (this.agGridList && this.agGridList.api.getModel().getRowCount() > 0) {
            this.agGridList.api.hideOverlay();
        }
    };

    // Filter function for no record found message
    onFilterChangedSummaryList = params => {
        this.agGridSummaryList = params;
        if (this.agGridSummaryList && this.agGridSummaryList.api.getModel().getRowCount() === 0) {
            this.agGridSummaryList.api.showNoRowsOverlay();
        }
        if (this.agGridSummaryList && this.agGridSummaryList.api.getModel().getRowCount() > 0) {
            this.agGridSummaryList.api.hideOverlay();
        }
    };

    generatePayload = filter => {
        if (filter?.from_date) {
            filter.from_date = moment(filter.from_date).format(Constant.PAYLOAD_DATE);
        }
        if (filter?.to_date) {
            filter.to_date = moment(filter.to_date).format(Constant.PAYLOAD_DATE);
        }
        return filter;
    };

    refreshList = () => {
        if (this.agGridList) {
            this.agGridList.api.deselectAll();
            this.setupGridList(this.agGridList);
            this.setIsSelectAll(false);
            this.setSummaryAllArr([]);
            this.setSelectedRowCount(0);
            this.setVisibleRowCount(0);
        }
    };

    refreshSummaryList = () => {
        if (this.agGridSummaryList) {
            this.setupGridSummaryList(this.agGridSummaryList);
        }
    };

    // call api to get records
    getList = payload => {
        return Axios.post(`/expense/acc-expense-manage/payments-summary`, payload).then(({ data }) => {
            if (data.list?.data?.length) {
                let startPage = (data.list.current_page - 1) * data.list.per_page;
                data.list.data.map((item, index) => {
                    item.srno = startPage + index + 1;
                    this.setVisibleRowCount(this.visibleRowCount + 1);
                    return null;
                });
            }
            if (this.visibleRowCount > 0 && this.visibleRowCount !== this.selectedRowCount) {
                this.setIsSelectAll(false);
            }
            this.list_data = data.list ? data.list.data : null;
            this.total_list = data.list.total;
            this.current_page_list = data.list.current_page;
            return data;
        });
    };

    // call api to get records
    getSummaryList = payload => {
        return Axios.post(`/expense/acc-expense-manage/payments-summary`, payload).then(({ data }) => {
            if (data.list?.data?.length) {
                let startPage = (data.list.current_page - 1) * data.list.per_page;
                data.list.data.map((item, index) => {
                    item.srno = startPage + index + 1;
                    return null;
                });
            }
            this.list_data_summary_list = data?.list ? data?.list?.data : null;
            this.total_summary_list = data?.list?.total;
            this.current_page_summary_list = data?.list?.current_page;
            return data;
        });
    };

    setVisibleRowCount = data => {
        this.visibleRowCount = data;
    };

    setSelectedRowCount = data => {
        this.selectedRowCount = data;
    };
    setIsSelectAll = selectFlag => {
        this.isSelectAll = selectFlag;
    };
    setSummaryAllArr = data => {
        this.summaryAllArr = data;
    };

    onFirstDataRendered = () => {
        if (this.isSelectAll === true && this.agGridList) {
            this.agGridList.api.forEachNode(node => {
                this.selectCount++;
                this.setSelectedRowCount(this.selectedRowCount + 1);
                node.setSelected(true);
            });
        }
    };

    onSelectAllRender = selectAllFlag => {
        if (selectAllFlag === true) {
            this.onFirstDataRendered();
        } else {
            this.agGridList.api.forEachNode(node => {
                this.setSelectedRowCount(0);
                node.setSelected(false);
            });
        }
    };

    // Call add api
    CreatePaymentSummary = formData => {
        return Axios.post(`expense/acc-expense-manage/save-acc-exp-payment-summary`, formData)
            .then(({ data }) => {
                if (this.agGridList) {
                    this.agGridList.api.deselectAll();
                    this.setupGridList(this.agGridList);
                    this.setIsSelectAll(false);
                    this.setSummaryAllArr([]);
                    this.setSelectedRowCount(0);
                    this.setVisibleRowCount(0);
                }
                return data;
            })
            .catch(({ response: { data } }) => {
                var errors = [];
                var notify = null;
                if (data && data?.STATUS) {
                    const { NOTIFICATION, ...fieldErrors } = data.STATUS;
                    if (NOTIFICATION) {
                        notify = NOTIFICATION[0];
                    }
                    Object.keys(fieldErrors).forEach(name => {
                        errors.push({ name, errors: data.STATUS[name] });
                    });
                }
                return Promise.reject({ errors, notify });
            });
    };

    ViewData = ID => {
        return Axios.get(`expense/acc-expense-manage/exp-payment-summary-view/${ID}`).then(({ data }) => {
            this.setViewValues(data.view);
            return data;
        });
    };
    DeleteData = formData => {
        return Axios.delete(`international/cancel-agy-payment-summary/` + formData.id)
            .then(({ data }) => {
                this.refreshSummaryList();
                return data;
            })
            .catch(response => {
                return Promise.reject(response);
            });
    };

    getSummaryLovList = payload => {
        return Axios.post(`expense/acc-expense-manage/lov-exp-payment-summary`, payload)
            .then(({ data }) => {
                if (!payload?.summary_id) {
                    this.dropdown_summary_list = data.exp_summary;
                }
                return data;
            })
            .catch(response => {
                return Promise.reject(response);
            });
    };

    PrintData = (ID, formdata) => {
        return Axios.post(`international/agy-payment-summary-print/` + ID, formdata)
            .then(({ data }) => {
                return data;
            })
            .catch(({ response: { data } }) => {
                var errors = [];
                var notify = null;
                const { NOTIFICATION, ...fieldErrors } = data.STATUS;
                if (data && data.STATUS) {
                    if (NOTIFICATION) {
                        notify = NOTIFICATION[0];
                    }
                    Object.keys(fieldErrors).forEach(name => {
                        errors.push({ name, errors: data.STATUS[name] });
                    });
                }
                return Promise.reject({ errors, notify });
            });
    };
}

decorate(AccountExpensePaymentSummaryStore, {
    per_page_list: observable,
    agGridList: observable,
    list_data: observable,
    total_list: observable,
    allColumnIdsList: observable,
    setupGridList: action,
    setPageSizeList: action,
    getList: action,
    setListFilterValues: action,
    onFilterChangedList: action,
    filter: observable,
    selectCount: observable,
    onFirstDataRendered: action,
    onSelectAllRender: action,
    setPaymentDetails: action,
    paymentDetails: observable,
    summaryAllArr: observable,
    setSummaryAllArr: action,
    isSelectAll: observable,
    setIsSelectAll: action,
    visibleRowCount: observable,
    setVisibleRowCount: action,
    selectedRowCount: observable,
    setSelectedRowCount: action,
    summary_list_filter: observable,
    agGridSummaryList: observable,
    list_data_summary_list: observable,
    per_page_summary_list: observable,
    total_summary_list: observable,
    allColumnIdsSummaryList: observable,
    setSummaryListFilterValues: action,
    setPageSizeSummaryList: action,
    onFilterChangedSummaryList: action,
    getSummaryList: action,
    viewValues: observable,
    setViewValues: action,
    deleteValues: observable,
    setDeleteValues: action,
    isTerminated: observable,
    setIsTerminated: action,
    setIsExistingSummary: action,
    isExistingSummary: observable,
    dropdown_summary_list: observable,
});
